'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _navItem = require('./navItem');

var _navItem2 = _interopRequireDefault(_navItem);

var _reactI18next = require('react-i18next');

var _i18next = require('i18next');

var _i18next2 = _interopRequireDefault(_i18next);

var _lodash = require('lodash');

var _reactHtmlParser = require('react-html-parser');

var _reactHtmlParser2 = _interopRequireDefault(_reactHtmlParser);

var _CTAButton = require('./CTAButton');

var _CTAButton2 = _interopRequireDefault(_CTAButton);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function CTAButtonWrapper() {
    var BREAK_POINT = 992;

    var _useTranslation = (0, _reactI18next.useTranslation)('header'),
        t = _useTranslation.t;

    var data = t("ctaButton", { returnObjects: true });

    var _useState = (0, _react.useState)(window.innerWidth > BREAK_POINT ? true : false),
        _useState2 = _slicedToArray(_useState, 2),
        isDesktop = _useState2[0],
        setIsDesktop = _useState2[1];

    (0, _react.useEffect)(function () {
        var resizeDimension = function resizeDimension() {
            var _breakPoint = BREAK_POINT;
            if (window.innerWidth <= _breakPoint) {
                setIsDesktop(false);
            } else {
                setIsDesktop(true);
            }
        };
        window.addEventListener("resize", resizeDimension);
        return function () {
            window.removeEventListener("resize", resizeDimension);
        };
    }, []);

    if ((0, _lodash.isEmpty)(data)) {
        return false;
    }

    var _isWrapper = false;
    var _wrapper = '';
    var _wrapperClass = [''];
    var _wrapperAlign = 'start';
    var _data = data;
    var _parseStyle = null;

    return _react2.default.createElement(_CTAButton2.default, {
        isWrapper: _isWrapper,
        Wrapper: _wrapper,
        WrapperClass: _wrapperClass,
        WrapperAlign: _wrapperAlign,
        data: _data,
        parseStyle: _parseStyle,
        isDesktop: isDesktop
    });
}

var TopNav = _react2.default.forwardRef(function (props, ref) {
    var lang = props.lang,
        isHeaderFixedTop = props.isHeaderFixedTop;
    var mainTopNavRef = ref.mainTopNavRef,
        topNavRef = ref.topNavRef;

    var headerStyle = (0, _react.useMemo)(function () {
        if (props.showMobileMenu) {
            return {};
        }
        return isHeaderFixedTop ? {
            position: 'fixed',
            width: '100%'
        } : {};
    }, [isHeaderFixedTop, props.showMobileMenu]);
    return _react2.default.createElement(
        'nav',
        {
            ref: mainTopNavRef,
            id: 'main-top-div',
            style: headerStyle,
            className: 'main-navbar navbar navbar-light navbar-expand-lg ' + (props.showMobileMenu ? "show-mobile-menu" : "") + ' ' + (props.darkMode ? "dark-color" : "")
        },
        _react2.default.createElement('a', {
            href: (0, _lodash.get)(window, "websiteSubPath", "") + "/",
            className: 'navbar-brand logo my-2 my-md-2 mx-2',
            onClick: function onClick(e) {
                e.preventDefault();
                props.onURLClick('[[aio]]home/' + lang + '/landing', "icon");
                props.setShowMobileMenu(false);
                props.handleMenuMouseEnter(null, null);
            }
        }),
        _react2.default.createElement(CTAButtonWrapper, null),
        _react2.default.createElement(BuildTopDesktopNav, _extends({}, props, { ref: topNavRef })),
        _react2.default.createElement(BuildTopMobileNav, props)
    );
});

var useFocus = function useFocus() {
    var htmlElRef = (0, _react.useRef)(null);
    var setFocus = function setFocus() {
        htmlElRef.current && htmlElRef.current.focus();
    };
    return [htmlElRef, setFocus];
};

var BuildTopDesktopNav = _react2.default.forwardRef(function (props, ref) {
    var _useTranslation2 = (0, _reactI18next.useTranslation)('header'),
        t = _useTranslation2.t;

    var _useState3 = (0, _react.useState)(false),
        _useState4 = _slicedToArray(_useState3, 2),
        focused = _useState4[0],
        setFocused = _useState4[1];

    var _useState5 = (0, _react.useState)(""),
        _useState6 = _slicedToArray(_useState5, 2),
        searchValue = _useState6[0],
        setSearchValue = _useState6[1];

    var _useFocus = useFocus(),
        _useFocus2 = _slicedToArray(_useFocus, 2),
        inputRef = _useFocus2[0],
        setInputFocus = _useFocus2[1];

    return _react2.default.createElement(
        'div',
        { className: 'collapse navbar-collapse justify-content-end', id: 'navbarSupportedContent' },
        _react2.default.createElement(
            'div',
            { className: 'flex-column' },
            _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'ul',
                    { className: 'navbar-nav justify-content-end sub-nav' },
                    !(0, _lodash.isEmpty)(t("topMiniNav", { returnObjects: true })) && (0, _lodash.isArray)(t("topMiniNav", { returnObjects: true })) && t("topMiniNav", { returnObjects: true }).map(function (obj, key) {
                        // console.log(obj)
                        return _react2.default.createElement(
                            'li',
                            { className: 'nav-item ' + (obj.forceActive ? "active" : "") + ' d-flex', key: key },
                            !(0, _lodash.isEmpty)(obj.iconPic) && _react2.default.createElement(
                                'div',
                                null,
                                _react2.default.createElement('img', {
                                    src: obj.iconPic,
                                    style: {
                                        width: 20,
                                        margin: '12px auto'
                                    }
                                })
                            ),
                            _react2.default.createElement(
                                'a',
                                {
                                    className: 'nav-link',
                                    href: props.returnFullURL(obj.url),
                                    target: obj.forceActive ? "" : "_blank",
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        props.onURLClick(obj.url, 'miniNav');
                                    },
                                    style: {
                                        color: !(0, _lodash.isEmpty)(obj.color) ? obj.color : '#808080',
                                        backgroundColor: !(0, _lodash.isEmpty)(obj.bgColor) ? obj.bgColor : 'transparent',
                                        fontWeight: (0, _lodash.isBoolean)(obj.bold) && obj.bold ? 'bold' : 'normal'
                                    }
                                },
                                (0, _reactHtmlParser2.default)(obj.title)
                            )
                        );
                    }),
                    _react2.default.createElement(
                        'li',
                        { className: 'd-flex' },
                        _react2.default.createElement(
                            'div',
                            {
                                className: 'nav-link',
                                onClick: function onClick() {
                                    props.handleChangeLang(_i18next2.default.language === 'en-US' ? "zh-HK" : "en-US");
                                }
                            },
                            _i18next2.default.language === 'en-US' ? '繁' : 'EN'
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'div',
                { className: 'justify-content-end d-flex align-content-center main-nav-wrap' },
                _react2.default.createElement(
                    'ul',
                    { className: 'navbar-nav main-nav', ref: ref },
                    !(0, _lodash.isEmpty)(t("pages", { returnObjects: true })) && (0, _lodash.isArray)(t("pages", { returnObjects: true })) && t("pages", { returnObjects: true }).map(function (obj, key) {
                        return _react2.default.createElement(_navItem2.default, {
                            key: obj.key || key,
                            itemIndex: key,
                            itemContent: obj,
                            handleMouseEnter: props.handleMenuMouseEnter,
                            type: 'mainNav',
                            onURLClick: props.onURLClick,
                            fullURL: props.returnFullURL(obj.url)
                        });
                    })
                ),
                !props.disableLogin && props.isLogin && _react2.default.createElement(
                    'div',
                    { className: 'main-nav-icon' },
                    _react2.default.createElement(
                        'div',
                        { onClick: function onClick() {
                                props.handleLoginPress();
                            } },
                        _react2.default.createElement('span', { className: 'icon ' + (props.isLogin ? "icon-logout" : "icon-my-acc") + ' align-self-end nav-icon-label' }),
                        !props.isLogin && _react2.default.createElement(
                            'span',
                            { className: 'button-word ml-1 align-self-end nav-icon-text' },
                            _react2.default.createElement(
                                'a',
                                {
                                    className: 'blue',
                                    target: "_blank",
                                    href: t("loginURL", { returnObjects: true }),
                                    onClick: function onClick(e) {
                                        e.preventDefault();
                                        props.handleLoginPress();
                                    }
                                },
                                t("login", { returnObjects: true })
                            )
                        )
                    )
                )
            )
        )
    );
});

var BuildTopMobileNav = function BuildTopMobileNav(props) {
    var _useTranslation3 = (0, _reactI18next.useTranslation)('header'),
        t = _useTranslation3.t;

    return _react2.default.createElement(
        'div',
        { className: 'm-outer-icon d-flex d-lg-none justify-content-end ml-auto align-items-center' },

        // render mobile NavItem dropdown
        props.headerChild(),
        !props.disableLogin && props.isLogin && _react2.default.createElement(
            'a',
            {
                className: 'mx-2 d-flex justify-content-center align-items-center',
                href: t("loginURL", { returnObjects: true }),
                target: "_blank",
                style: { color: '#00508B' },
                onClick: function onClick(e) {
                    e.preventDefault();
                    // props.onURLClick(t("loginURL",{ returnObjects: true }), (t("gtmTagName",{ returnObjects: true })) );
                    // props.setShowMobileMenu(!props.showMobileMenu);
                    // props.handleMenuMouseEnter(null,null);
                    props.handleLoginPress();
                }
            },
            _react2.default.createElement('span', { className: 'navIcon icon ' + (props.isLogin ? "icon-logout" : "icon-my-acc") })
        ),
        _react2.default.createElement(
            'button',
            {
                onClick: function onClick() {
                    props.setShowMobileMenu(!props.showMobileMenu);
                    props.handleMenuMouseEnter(null, null);
                },
                className: 'navbar-toggler border-0 px-0 d-flex flex-column mx-2',
                type: 'button',
                'data-toggle': 'collapse',
                'aria-controls': 'navbarSupportedContent',
                'aria-expanded': 'false',
                'aria-label': 'Toggle navigation'
            },
            _react2.default.createElement('span', { className: 'm-1' }),
            _react2.default.createElement('span', { className: 'm-1' }),
            _react2.default.createElement('span', { className: 'm-1' })
        )
    );
};

exports.default = TopNav;